module.exports = __webpack_public_path__ + "img/131.5c379ad1.svg";